<div *ngFor="let table of arrTable" class="elementinnerholder" [attr.data-docid]="table.docid" id="navmain">

    <div class="container containerwo">
        <div class="row">
            <div class="col-xs-6 col-sm-3 col-md-3">
                <img id="headerlogo" *ngIf="table.logoimagefileid > 0" src="/.ci.{{table.logoimagefileid}}.250.70.png" alt="" title="" class="img-responsive" />
            </div>

            <div class="col-xs-6 col-sm-9 col-md-9">
                <nav class="navbar navbar-default">
                    <div class="navbar-header">
                        <button id="tt" type="button" class="navbar-toggle collapsed" data-bs-toggle="collapse" data-bs-target="#headernavigation" aria-controls="headernavigation">
                            <span class="sr-only">Toggle navigation</span>
                            <span class="icon-bar top-bar"> </span>
                            <span class="icon-bar middle-bar"> </span>
                            <span class="icon-bar bottom-bar"> </span>
                        </button>
                    </div>

                    <div class="collapse navbar-collapse" id="headernavigation">
                        <div class="closeicon right visible-xs" onclick="$('.navbar-collapse').collapse('hide');">
                            X
                        </div>
                        <div class="clear-all visible-xs"> </div>

                        <ul class="nav navbar-nav">
                            <!-- delimiters -->
                            <li *ngFor="let delimiter of arrTable1">
                                <a href="javascript:void(0)" onclick="scrollToElement(this, ''); $('.navbar-collapse').collapse('hide');" class="navdel" [attr.data-webpagedefinitionitemid]="delimiter.webpagedefinitionitemid">
                                    {{ delimiter.delimitertitle }}
                                </a>
                            </li>

                            <!-- culture related -->
                            <li class="cult" *ngFor="let culture of arrTable2">
                                <a href="{{culture.url}}" id="ccul">
                                    &nbsp;
                                    <img src="/images/culture.png" alt="{{ culture.code }}" />
                                    &nbsp;
                                    {{ culture.code }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>

            <div class="clear-all"> </div>
        </div>
    </div>
</div>
